<template>
  <div class="GolfMemberShip">
    <div class="homepage">
      <!-- <p class="blackStandard-text golfParkText-width" v-html="acf.acf.racepark_blog"></p> -->
      <!-- <b-link :to="'/contact'">
        <b-button class="golfMemberBtn" variant="">Get in Touch Today</b-button>
      </b-link> -->
      <!-- <b-row class="container bannersec">
        <b-col>
            <b-link to="/contact">
                <template  v-if="isMobile(true)">
                    <img class="banner" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2025/05/mob2.jpg">
                </template>
                <template v-else>
                    <img class="banner" src="https://wp-ocssport.ocs-sport.com/racepark/wp-content/uploads/sites/7/2025/05/2.jpg">
                </template>
            </b-link>
        </b-col>
      </b-row> -->
      <!-- desktop  -->
      <b-row class="membership-Options container above1400">
        <b-col lg="6" sm="12" v-for="(racePack, index) in acf.acf.price_banner_sections" :key="index" class="packageSections">
            <div class="borderMemberShip">
                <h2 class="blacktitle">{{racePack.price_banner_title}} </h2>
                <p class="descript" v-html="racePack.price_banner_text_box"></p>
            </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Banner Price',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
           process.env.VUE_APP_API_URL + 'racepark' + "/wp-json/wp/v2/pages/4" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.packageSections {
    /* margin-bottom: 60px; */
    margin-bottom: 20px;
}
img.raceparkImage {
    width: 100%;
}
p.descript {
    font-size: 24px;
    color: #11182F;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    text-align: left;
    /* padding-top: 20px; */
    padding-top: 40px;
}
.bannersec {
    display: block;
    margin: auto;
    padding-bottom: 60px;
}
.banner {
    width: 100%;
}
ul.MemberBullet-Points.pMonth {
    margin-top: 93px;
}
img.ImageLogo.Car {
    width: 120px;
    height: auto;
    margin-top: 41px;
}
img.ImageLogo.member {
    height: 50px;
    position: relative;
    top: 20px;
    margin-bottom: 20px;
}
span.sideText {
    font-size: 32px;
    display: block;
}
button.MemberBtn {
    background-color: #D80E1F;
    border-color: #D80E1F!important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    /* width: 100%; */
    width: 252px;
    height: 54px;
    font-family: "noto-sans", sans-serif;
    /* height: 35px; */
}
button.MemberBtn:hover {
    background-color: #707070;
    border-color: #707070!important;
    color: #fff;
}
.memberEnquiry {
    position: absolute;
    /* width: 100%;
    padding-left: 15px;
    padding-right: 50px; */
    bottom: -35px;
}
.Orangetitle {
    color: #D80E1F;
    font-size: 40px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
}
.blacktitle {
    color: #11182F;
    font-size: 40px;
    /* font-size: 28px; */
    font-family: "korolev", sans-serif;
    font-weight: 700;
    font-style: italic;
    text-align: left;
    height: 50px;
    padding-top: 20px;
    /* margin-top: 20px; */
}
.GolfMemberShip {
    padding: 20px;
    padding-bottom: 20px;
}
.blackStandard-text {
    font-size: 24px;
    color: #11182F;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.golfParkText-width {
    width: 70%;
    text-align: center;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 30px;
}
button.golfMemberBtn {
    background-color: #1A1A1A;
    border-color: #1A1A1A!important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 535px;
    height: 54px;
    margin-top: 25px;
    margin-bottom: 50px;
    font-family: "noto-sans", sans-serif;
}
button.golfMemberBtn:hover {
    background-color: #707070;
    border-color: #707070!important;
    color: #fff;
}
.membership-Options {
    margin-top: 60px;
    margin: auto;
}
h3.Membership-Prices {
    color: #D80E1F;
    font-size: 29px;
    padding-top: 5px;
    font-family: "noto-sans", sans-serif;
    font-weight: 700;
    font-style: normal;
}
.perMonth {
    color: #D80E1F;
    font-size: 15px;
    font-weight: bold;
}
.borderMemberShip {
    /* border: 1px solid #11182F; */
    padding-top: 40px;
    padding-bottom: 40px;
    /* height: 400px; */
    /* height: 1000px; */
    /* height: 1200px; */
    /* height: 1100px; */
    /* height: 800px; */
}
ul.MemberBullet-Points {
    color: #11182F;
    font-size: 22px;
    text-align: left;
    list-style-type: circle;
    margin-top: 50px;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    padding-right: 50px;
    padding-left: 58px;
}
ul.MemberBullet-Points > li {
    padding-bottom: 10px;
}

/* MobileCSS */
@media only screen and (min-width: 1401px) {
    .below1400 {
        display: none;
    }
}
@media only screen and (max-width: 1400px) {
    /* .above1400 {
        display: none;
    } */
    .PayandPlay {
        height: 600px;
    }
    .blacktitle {
        color: #11182F;
        font-size: 40px;
        font-family: "korolev", sans-serif;
        font-weight: 700;
        font-style: italic;
        /* padding-left: 20px; */
        padding-right: 20px;
    }
    .PandP {
        margin-bottom: 30px;
    }
}
@media only screen and (min-width: 1200px) {
    ul.MemberBullet-Points.MBP-desktop {
        margin-top: 53px; 
    }
}
@media only screen and (max-width: 1024px) {
    .PayandPlay {
        height: 540px!important;
    }
}
@media only screen and (max-width: 990px) {
    .borderMemberShip {
        height: 1100px;
        margin-bottom: 20px;
    }
    .memberEnquiry {
        position: absolute;
        width: 100%;
        padding-left: 15px;
        padding-right: 50px;
        bottom: 0;
    }
}
@media only screen and (max-width: 768px) {
    p.descript {
        font-size: 20px;
        color: #11182F;
        font-family: "noto-sans", sans-serif;
        font-weight: 400;
        font-style: normal;
        text-align: left;
        /* padding-top: 20px; */
        padding-top: 40px;
    }
    img.raceparkImage {
        width: 100%;
        margin-top: 4em;
    }
    button.MemberBtn {
        background-color: #D80E1F;
        border-color: #D80E1F!important;
        border-radius: 50px;
        /* width: 163px; */
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: auto;
        height: 54px;
        font-family: "noto-sans", sans-serif;
        /* height: 35px; */
    }
    button.MemberBtn:hover {
        background-color: #707070;
        border-color: #707070!important;
        color: #fff;
    }
    h3.Membership-Prices {
        font-size: 20px;
    }
    .blacktitle {
        font-size: 40px;
    }
    .blackStandard-text {
        font-size: 20px;
        color: #11182F;
        font-family: "noto-sans", sans-serif;
        font-weight: 400;
        font-style: normal;
    }
    .Orangetitle {
        font-size: 36px;
    }
    .GolfMemberShip {
        padding: 25px;
    }
    .container {
        padding-left: 0;
        padding-right: 0;
    }
    button.golfMemberBtn {
        background-color: #1A1A1A;
        border-color: #1A1A1A!important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        width: 100%;
        height: 54px;
        margin-top: 25px;
    }
    button.golfMemberBtn:hover {
        background-color: #D80E1F;
        border-color: #D80E1F!important;
        color: #fff;
    }
    .golfParkText-width {
        width: 100%; 
        text-align: center;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .borderMemberShip {
        /* height: auto!important; */
        margin-bottom: 20px;
    }
    ul.MemberBullet-Points {
        padding-left: 30px; 
        font-size: 20px;
        padding-bottom: 30px;
    }
    .memberEnquiry {
        bottom: 0;
    }
}
@media only screen and (max-width: 500px) {
    ul.MemberBullet-Points {
        padding-left: 30px;
        font-size: 18px;
        padding-bottom: 30px;
    }
    .borderMemberShip {
        height: auto !important;
        margin-bottom: 0px;
        padding-bottom: 0px;
    }
}
</style>
